export default __webpack_public_path__ + "static/media/notFound.67030d9b.jpg";